<template>
  <div>
    <el-table :data="records" stripe>
      <el-table-column
        :width="columnWidth"
        label="插座号"
        prop="socketNum"
        align="center"
      />
      <el-table-column label="插座ID" prop="id" align="center" />
      <el-table-column
        label="状态"
        prop="state"
        align="center"
        v-if="this.$route.query.versions == 3"
      >
        <template #default="scope">
          <div :class="computeClass(scope.row.state[0]) + ' state'">
            {{ scope.row.state[0] }}
          </div>
          <div :class="computeClass(scope.row.state[1]) + ' state'">
            {{ scope.row.state[1] }}
          </div>
        </template>
        <!--        <div :class="computeClass('空闲') + ' state'">空闲</div>-->
        <!--        <div :class="computeClass('使用中') + ' state'">使用中</div>-->
      </el-table-column>
      <el-table-column
        :width="columnWidth"
        label="插座UID"
        prop="czid"
        align="center"
        v-if="this.$route.query.versions == 3"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <template
            v-if="
              editDto.qrCodeMap.get(scope.row.socketNum) !== undefined &&
              editDto.qrCodeMap.get(scope.row.socketNum).qrCodeUrl !== undefined
            "
          >
            <el-button
              id="unbind"
              size="small"
              type="danger"
              @click="unbind(scope.row.socketNum)"
              >解&emsp;&emsp;绑</el-button
            >
          </template>
          <template v-else>
            <el-button
              plain
              size="small"
              type="primary"
              @click="socketBind(scope.row.socketNum)"
              >扫码绑定
            </el-button>
          </template>

          <template
            v-if="
              editDto.qrCodeMap.get(scope.row.socketNum) !== undefined &&
              editDto.qrCodeMap.get(scope.row.socketNum).qrCodeUrl !==
                undefined &&
              editDto.versions === '3'
            "
          >
            <el-button
              id="retry"
              size="small"
              type="danger"
              @click="agengRetrySetSocketNumClick(scope.row.socketNum)"
              >补发配置
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-button v-if="editDto.versions === '3'" @click="addShowSocket"
      >添加</el-button
    >
  </div>
</template>

<script>
import agentGetSocketsByDeviceId from "@/api/device/charging-pile-manage/agentGetSocketsByDeviceId";
import searchMixin from "@/mixin/searchMixin";
import scanMixin from "@/mixin/scanMixin";
import resDispose from "@/mixin/resDisposeMixin";
import agentSetSocketNum2TwoWaySocket from "@/api/device/charging-pile-manage/agentSetSocketNum2TwoWaySocket";
import { getQueryArgs } from "@/utils/utils";
import agentBindQrCode from "@/api/device/socket-qrcode-manage/agentBindQrCode";
import agengUnBindQrCode from "@/api/device/socket-qrcode-manage/agengUnBindQrCode";
import agengRetrySetSocketNum from "@/api/device/socket-qrcode-manage/agengRetrySetSocketNum";
import agentGetQrCodeList from "@/api/device/charging-pile-manage/agentGetQrCodeList";

export default {
  name: "PowerStationDetailFour",
  mixins: [searchMixin, scanMixin, resDispose],
  data() {
    return {
      records: [],
      params: {
        ids: this.$route.query.ids,
        sortName: "socketNum",
        sortType: "ASC",
      },
      editDto: {
        versions: this.$route.query.versions,
        id: this.$root._route.params.id,
        qrCodeMap: new Map(),
      },
      isMakeUpBlank: false,
      windowWidth: document.documentElement.clientWidth, //获取屏幕宽度
      windowHeight: document.documentElement.clientHeight, //获取屏幕高度
      isChangeBoxWidth: false,
      columnWidth: 100,
    };
  },
  methods: {
    socketBind(socketNum) {
      // agentBindQrCode("e14526fa71744f3a93131f572e9cd8ec", this.editDto.id, socketNum).then(res2 => {
      //   this.resDispose({
      //     res: res2, success: () => {
      //       this.fetchData()
      //       // this.editDto.qrCodeMap.get(socketNum).qrCodeUrl = getQueryArgs(res.resultStr)['code'];
      //     }
      //   });
      // });
      this.scan({
        callBack: (res) => {
          if (this.editDto.versions === "3") {
            agentSetSocketNum2TwoWaySocket({
              qrCode: getQueryArgs(res.resultStr)["code"],
              socketNum: socketNum,
              chargePileId: this.editDto.id,
            }).then((res2) => {
              this.resDispose({
                res: res2,
                success: () => {
                  this.fetchData();
                  // this.editDto.qrCodeMap.get(socketNum).qrCodeUrl = getQueryArgs(res.resultStr)['code'];
                },
              });
            });
          } else {
            agentBindQrCode(
              getQueryArgs(res.resultStr)["code"],
              this.editDto.id,
              socketNum
            ).then((res2) => {
              this.resDispose({
                res: res2,
                success: () => {
                  this.fetchData();
                  // this.editDto.qrCodeMap.get(socketNum).qrCodeUrl = getQueryArgs(res.resultStr)['code'];
                },
              });
            });
          }
        },
      });
    },
    // socketBind(socketNum) {
    //       if (this.editDto.versions === "3") {
    //         agentSetSocketNum2TwoWaySocket({
    //           qrCode: '617ae343304645289fde53a2f894c6b8',
    //           socketNum: socketNum,
    //           chargePileId: this.editDto.id,
    //         }).then(res2 => {
    //           this.resDispose({
    //             res: res2, success: () => {
    //               this.fetchData()
    //               // this.editDto.qrCodeMap.get(socketNum).qrCodeUrl = '617ae343304645289fde53a2f894c6b8';
    //             }
    //           });
    //         });
    //       } else {
    //         agentBindQrCode('4e9c26e2c6294ae7bd00389e8afd67df', this.editDto.id, socketNum).then(res2 => {
    //           this.resDispose({
    //             res: res2, success: () => {
    //               this.fetchData()
    //               this.editDto.qrCodeMap.get(socketNum).qrCodeUrl = '4e9c26e2c6294ae7bd00389e8afd67df';
    //             }
    //           });
    //         });
    //       }
    // },
    unbind(socketNum) {
      this.$confirm("您是否确认插座号为 " + socketNum + " 解绑?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          agengUnBindQrCode(this.editDto.id, socketNum)
            .then((res) => {
              this.resDispose({
                res,
                success: () => {
                  // this.editDto.qrCodeMap.get(socketNum).qrCodeUrl = undefined;
                  this.fetchData();
                  this.$message({
                    type: "success",
                    message: "解绑成功!",
                  });
                },
              });
            })
            .catch((err) => {
              alert("出错了，解绑失败！");
              alert(err);
              alert(JSON.stringify(err));
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });

      //启用宽度调整
      this.isChangeBoxWidth = true;
      this.changeBoxWidth(this.windowWidth);
    },
    agengRetrySetSocketNumClick(socketNum) {
      agengRetrySetSocketNum({
        chargePileId: this.editDto.id,
        socketNum: socketNum,
      })
        .then((res) => {
          this.resDispose({
            res,
            success: () => {
              this.$message.success("发送成功");
              this.fetchData();
            },
          });
        })
        .catch((err) => {
          alert("出错了,补发失败！");
          alert(err);
          alert(JSON.stringify(err));
          this.fetchData();
        });
    },
    //查找最大插座号
    searchMaxSocketNum(qrCodeMap) {
      let max = 0;
      qrCodeMap.forEach(function (a) {
        max = max > a.socketNum ? max : a.socketNum;
      });
      return max;
    },
    addShowSocket() {
      let socketNum = this.searchMaxSocketNum(this.editDto.qrCodeMap) + 1;
      if (this.editDto.qrCodeMap.size > 0) {
        if (this.editDto.qrCodeMap.size >= 40) {
          this.$message.error("插座数量最多为40");
          return;
        }
      } else {
        socketNum = 1;
      }
      this.editDto.qrCodeMap.set(socketNum, {
        socketNum: socketNum,
        qrCodeUrl: undefined,
      });
      this.records.push({
        socketNum: socketNum,
        state: "待绑定",
        czid: "待绑定",
      });
    },
    formatRecords(records) {
      let data = new Map();
      records.forEach(function (e) {
        // console.log(e)
        let socket = data.get(e.socketNum);
        let preState = e.state == "0" ? "空闲" : "使用中";
        if (e.netStatus == -1) {
          preState = "故障";
        }
        if (socket == undefined) {
          socket = {
            socketNum: e.socketNum,
            state: [preState],
            czid: e.czid,
            id: e.id
          };
          data.set(e.socketNum, socket);
        } else {
          socket.state.push(preState);
          if (e.firstsd == "0") {
            socket.czid = e.czid;
          }
        }
      }); 
      // map转成数组是二维数组
      const resultArr = Array.from(data);
      // console.log(resultArr)
      let index = 0;
      let asc = this.params.sortType == "ASC";
      if (this.params.sortName == "czid") index = 1;
      resultArr.sort((a, b) => {
        // console.log(a)
        if (index == 0) {
          if (asc) {
            return a[index] - b[index];
          } else {
            return -(a[index] - b[index]);
          }
        } else {
          if (asc) {
            return a[index].czid - b[index].czid;
          } else {
            return -(a[index].czid - b[index].czid);
          }
        }
      });

      let result = [];
      resultArr.forEach(function (e) {
        result.push(e[1]);
      }); 
      this.records = result;
    },
    formatQrCodeList(qrCodeList) {
      let map = new Map();
      qrCodeList.forEach(function (e) {
        let socketNum = e.socketNum;
        let qrCodeUrl = e.qrCodeUrl;
        map.set(e.socketNum, { socketNum, qrCodeUrl });
      });
      console.log(map);
      this.editDto.qrCodeMap = map;
    },
    fetchData() {
      this.records = [];
      this.editDto.qrCodeMap.clear();
      this.isMakeUpBlank = false;
      agentGetSocketsByDeviceId(this.params).then((res) => {
        this.formatRecords(res.data.records);
        this.total = res.data.total;
      });
      agentGetQrCodeList(this.editDto.id).then((res) => {
        this.formatQrCodeList(res.data);
      });
    },
    makeUpBlank() {
      if (
        this.$route.query.versions === "3" &&
        this.records.length > 0 &&
        this.editDto.qrCodeMap.size > 0 &&
        !this.isMakeUpBlank
      ) {
        let maxSocketNum = this.searchMaxSocketNum(this.editDto.qrCodeMap);
        for (let i = 1; i <= maxSocketNum; i++) {
          let e = this.editDto.qrCodeMap.get(i);
          if (e == undefined) {
            this.editDto.qrCodeMap.set(i, {
              socketNum: i,
              qrCodeUrl: undefined,
            });
            this.records.push({
              socketNum: i,
              state: "待绑定",
              czid: "待绑定",
            });
          }
        }
        this.records.sort((a, b) => {
          return a.socketNum - b.socketNum;
        });
        this.isMakeUpBlank = true;
      }
    },
    watchWindow() {
      var that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; //获取屏幕高度
          that.windowWidth = window.fullWidth; //获取屏幕宽度
        })();
      };
    },
    changeBoxWidth(val) {
      if (this.isChangeBoxWidth) {
        let box = document.getElementsByClassName("el-message-box")[0];
        if (val < 420) {
          box.style.width = "80%";
        } else {
          box.style.width = "420px";
        }
      }

      this.setMinColumn(val);
    },
    setMinColumn(width) {
      if (width < 400) {
        this.columnWidth = 50;
      } else {
        this.columnWidth = 100;
      }
    },
  },
  mounted() {
    this.fetchData();
    //实时监控屏幕大小
    this.watchWindow();
    //调整min-column
    this.setMinColumn(this.windowWidth);
  },
  watch: {
    records: {
      handler(item) {
        //  console.log('records更新了')
        console.log(item);
        this.makeUpBlank();
      },
    },
    "editDto.qrCodeMap": {
      handler() {
        //  console.log('qrCodeMap更新了')
        this.makeUpBlank();
      },
    },

    // windowHeight (val) {
    //   let that = this;
    // },
    windowWidth(val) {
      // let that = this;
      //如果宽度<420则将消息宽度设为80%
      this.changeBoxWidth(val);
    },
  },
  computed: {
    computeClass() {
      return function (state) {
        switch (state) {
          case "空闲":
            return "leisure";
          case "使用中":
            return "use";
          case "故障":
            return "error";
        }
      };
    },
  },
};
</script>

<style>
#unbind {
  margin: 1px;
}

#retry {
  margin: 1px;
}

.state {
  display: inline-block;
  width: 50px;
  height: 20px;
  color: white;
  margin: 1px;
  line-height: 20px;
  text-align: center;
}

.leisure {
  background-color: yellowgreen;
}

.use {
  background-color: orange;
}

.error {
  background-color: red;
}

/*.el-message-box{*/
/*  width: 80%;*/
/*}*/

/*.el-message-box {*/
/*  text-align: center;*/
/*}*/
/*.el-message-box__status {*/
/*  left: 20%;*/
/*}*/

/*.el-message-box__btns button:nth-child(2) {*/
/*  margin-right: 90px;*/
/*}*/
</style>
